var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLockedStatus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.471 7.41a2.529 2.529 0 1 1 5.057 0v.858h1.8V7.41a4.329 4.329 0 1 0-8.657 0v.857h1.8zm-.385 3.883h5.829c.71 0 1.286.576 1.286 1.286v4.115c0 .71-.576 1.286-1.286 1.286h-5.83c-.71 0-1.285-.576-1.285-1.286v-4.115c0-.71.576-1.286 1.286-1.286M6 12.58a3.086 3.086 0 0 1 3.086-3.086h5.829A3.086 3.086 0 0 1 18 12.58v4.115a3.086 3.086 0 0 1-3.085 3.085h-5.83A3.086 3.086 0 0 1 6 16.694zm6.9 1.69a1.286 1.286 0 1 0-1.8-.003v2.084a.9.9 0 1 0 1.8 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockedStatus);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };